<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="1" right>開化寺看起來跟平常沒什麼不同，怪盜到底在哪裡？</npc>
              <npc :npc-id="0">我想提示一定就是那個Negative慈雲⋯⋯</npc>
              <npc :npc-id="0">⋯⋯</npc>
              <npc :npc-id="0">⋯⋯原來如此。</npc>
              <npc :npc-id="1" right>你知道答案了嗎？</npc>
              <npc :npc-id="0">小蘇，你知道Negative的意思嗎？</npc>
              <npc :npc-id="1" right>當然知道啦！你等等，我查一下英文辭典——</npc>
              <npc :npc-id="0">一般來說，我們把這種情況定義為『不知道』。</npc>
              <npc :npc-id="1" right>我只是確定一下嘛！嗯，Negative是正負值的負，或是否定的意思。</npc>
              <npc :npc-id="0">沒錯，所以這是『否定』慈雲的意思。小蘇，你仔細看看這個環境，如果否定慈雲的話，會冒出什麼答案呢？</npc>

              <story-image :src="require(`@/assets/images/pics/第6章_2-1_開化寺.jpg`)" size="lg"></story-image>
              <!-- （圖片：開化寺） -->

              <npc :npc-id="1" right>⋯⋯啊！我知道了！</npc>
              <npc :npc-id="0">很好，我們就去面對一切的真相吧！</npc>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>

        <section class="question">
          <div class="container">

            <!-- 要改的內容 -->
            <question-part hint="Negative是正負值的負，或是否定的意思。" morehint="有找到慈雲在哪裡了嗎？如果不是慈雲的話，那另一邊是？">
              <p>Negative慈雲，那你應該通過何處？答案兩個字。</p>
            </question-part>
            <!-- 要改的內容到此 -->

          </div>
        </section>

      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage6_2',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第六章 - 2',
      isQuestion: true,
      stageId: 'cloud',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
